// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import ElementUI from 'element-ui';
import router from './router'
import store from './store'
import "./router/permission"
import 'element-ui/lib/theme-chalk/index.css';
import App from './App.vue';
import 'lib-flexible'

import {
  timeChange
} from './utils/timeChange.js'
Vue.prototype.timeChange = timeChange

Vue.use(ElementUI);

// 文字截取
Vue.prototype.$textTruncation = function (text) {
  let start = text.slice(0, 4)
  let end = text.slice(-4)
  return start + '...' + end
}

// 公用请求
import httpRequest from '@/utils/request'
Vue.prototype.$http = httpRequest

// 公用api
import apiList from '@/utils/api'
Vue.prototype.apiList = apiList

// 国际化价格
Vue.prototype.formatWithCommas = function (number) {
  return new Intl.NumberFormat().format(number);
}

Vue.prototype.toChineseNumber = function (number) {
  const numbers = ['', '一', '二', '三', '四', '五', '六', '七', '八', '九'];
  const units = ['', '十', '百', '千'];
  let text = '';

  if (number === 0) {
    return '零';
  }

  let num = number;
  let digit = 0;

  while (num > 0) {
    const current = num % 10;
    const unit = units[digit % 4];

    if (current !== 0) {
      text = numbers[current] + unit + text;
    }

    num = Math.floor(num / 10);
    digit++;
  }

  return text;
}

Vue.prototype.$pinjie = function (text) {
  return `'${text}'`;
}

// 禁止警告输出
console.log = () => { }
console.warn = () => { }
console.error = () => { }

// // 往前退3天
// const threeDaysAgo = today.subtract(3, 'days');
// // 输出格式化的日期
// console.log(threeDaysAgo.format('YYYY-MM-DD'));

Vue.config.productionTip = false

router.afterEach((to, from, next) => {
  window.scrollTo(0, 0);
});
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: {
    App
  },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js